import ServicePeriodInfo from './ServicePeriodInfo';

export default ServicePeriodInfo;
